<template>
    <div style="padding: 4px 10px; text-align:center; background-color: #000000; color: #fff; font-size: 14px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <span style="font-weight: 300; font-size: 11px;">
            Listo para la faena, ¿pero sin examen médico?
        </span>
        <a target="_blank" href="https://examine.cl/?utm_source=mineria_mine-class&utm_campaign=agenda_tu_examen_25&utm_content=banner_sitio" style="background-color: #EF574F; padding: 5px 12px; border-radius: 30px; color: #FFFFFF; text-transform: uppercase; font-weight: 600; display: inline-block; font-size: 10px; margin-left: 6px; vertical-align: middle;">Gestiona tu examen</a>
    </div>
</template>

<script>
export default {
    name: 'BannerTop'
}
</script>